import { useCallback, useState } from "react";
import { useSaveDownloaded } from "../../../../../lib/hooks/useSaveDownloaded";
import ReportService from "../../../../../services/reportGeneration";

export const useExport = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { save } = useSaveDownloaded(
    "UPC Numbers.xlsx",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
    setIsLoading
  );

  const onExportClicked = useCallback(async () => {
    try {
      setIsLoading(true);

      const res: any = await ReportService.exportByName("ImpoundUpcNumbers", null);

      save(res);
    } catch {
      setIsLoading(false);
    }
  }, [save]);

  return { onExportClicked, isLoading };
};
